// TODO: move to global helpers
export const decode = (input: string) => {
  return JSON.parse(atob(input))
}

const undoUrlEncoding = (enc: string) => {
  return enc.replace('_', '/').replace('–', '+')
}

export const extractUserId = (
  token: string,
  environment: 'development' | 'production',
) => {
  try {
    const userId = decode(undoUrlEncoding(token.split('.')[1]))[environment === 'production'
      ? 'https://api.parafin.com/user_authorization'
      : 'https://api.dev.parafin.com/user_authorization'
    ].app_metadata.userId
    return userId
  } catch {
    return null
  }
}
